$(document).ready(function(){
  $(".liquid-custom-block-desc p").hide();

  $(".liquid-custom-block h4").on("click", function() {
    $(this).parent().find("p").slideToggle("slow");
  });
});



$('.icon-hamburger').on('click', function() {
          if ($(window).width() <= 767) {
            $('header').addClass('relative-position');
          }
        });

$('.icon-close').on('click', function() {
          if ($(window).width() <= 767) {
            $('header').removeClass('relative-position');
          }
        });

